<template>
    <FlyerlineModal ref="modal" @close="handleClose" name="addressBookAddAddress">
        <!-- type 2 = lieferadresse -->
        <SkyFormLoader formName="shop_addaddress" :params="{shop_addressKeyType: 2}"
                       @success="handleConfirm">
        </SkyFormLoader>
    </FlyerlineModal>
</template>

<script>

    import ComponentPromise from "mixins/ComponentPromise";
    import FlyerlineModal from "fragments/FlyerlineModal";
    import SkyFormLoader from "fragments/SkyFormLoader";

    export default {
        name: "AddressBookAddAddress.vue",
        components: {FlyerlineModal, SkyFormLoader},
        mixins: [ComponentPromise],
        methods: {
            open() {
                // this.$modal.show("addressBookAddAddress")
                this.$refs.modal.open()
                return this.createPromise()
            },
            handleConfirm(data) {
                this.resolver(data)
                this.$refs.modal.close()
            },
            handleClose() {
                this.rejectOldPromise('Window Closed without Confirmation')
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>